import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { AuthResponseComponent } from './auth-response/auth-response.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ScenarioLibraryComponent } from './dashboard/scenario-library/scenario-library.component';
import { ScenarioCreationComponent } from './scenario-creation/scenario-creation.component';
import { CREATION, DASHBOARD, LIBRARY, NEW_FEATURE } from './shared/static';
import { NewFeatureComponent } from './new-feature/new-feature.component';

const routes: Routes = [
  // { path: 'auth-response', component: AuthResponseComponent },
  {
    path: LIBRARY,
    component: ScenarioLibraryComponent,
    canActivate: [MsalGuard],
  },
  {
    path: CREATION,
    component: ScenarioCreationComponent,
    canActivate: [MsalGuard],
  },
  {
    path: DASHBOARD,
    component: DashboardComponent,
    canActivate: [MsalGuard],
  },
  { path: NEW_FEATURE, component: NewFeatureComponent },
  { path: '**', redirectTo: LIBRARY },
];

const isIframe = window !== window.parent && !window.opener;

console.log('isIframe :: ', isIframe);

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'reload',
      // initialNavigation: !isIframe ? 'enabled' : 'disabled', // Don't perform initial navigation in iframes
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
